// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormWrapper_wrapper__sFlt5 {
    /*position: relative;*/
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/
    /*align-items: center;*/

    min-height: 100%;
    flex: 1 1;
    /*padding-bottom: 30px;*/
}

.FormWrapper_wrapper__sFlt5.FormWrapper_view__CgAH8 {
    width: clamp(748px, 1040px, 60vw);
}

.FormWrapper_wrapper__sFlt5.FormWrapper_small__4k8iP {
    width: 748px;
    max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/layout/FormWrapper/FormWrapper.module.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;;IAEvB,gBAAgB;IAChB,SAAO;IACP,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".wrapper {\n    /*position: relative;*/\n    display: flex;\n    flex-direction: column;\n    /*justify-content: center;*/\n    /*align-items: center;*/\n\n    min-height: 100%;\n    flex: 1;\n    /*padding-bottom: 30px;*/\n}\n\n.wrapper.view {\n    width: clamp(748px, 1040px, 60vw);\n}\n\n.wrapper.small {\n    width: 748px;\n    max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `FormWrapper_wrapper__sFlt5`,
	"view": `FormWrapper_view__CgAH8`,
	"small": `FormWrapper_small__4k8iP`
};
export default ___CSS_LOADER_EXPORT___;
